import http from '@/utils/http';
import config from '@/config';
import { ScreenDowntimeRecord } from '@/types/api/downtime';

export async function sendScreenDowntime(record: ScreenDowntimeRecord): Promise<void> {
  await http.post(`${config.apiUrl}userapi/screen/downtime`, record);
}
